module.exports = __webpack_public_path__ + "img/gb.c4cd6642.svg";